const fishes = [
  { id: 1, text: ">><<", left: "8%", top: "18%", rotate: -14 },
  { id: 2, text: "<><", left: "18%", top: "74%", rotate: 8 },
  { id: 3, text: "><(((°>", left: "84%", top: "24%", rotate: 10 },
  { id: 4, text: "<><", left: "72%", top: "84%", rotate: -12 },
];

export function FloatingFish() {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      {fishes.map((fish) => (
        <span
          key={fish.id}
          className="absolute text-[0.65rem] font-mono opacity-[0.05] tracking-[0.2em] text-foreground/70"
          style={{ left: fish.left, top: fish.top, transform: `rotate(${fish.rotate}deg)` }}
        >
          {fish.text}
        </span>
      ))}
    </div>
  );
}
